import React, { createContext, useContext, useMemo } from 'react';
import { GridBreadcrumb } from '../grid-types';
import { LinkFieldRouter } from 'components/link-field/link-field';
import { useEadTreeContext } from '../grid-ctx/EadTreeCtx';
import { LevelDefaultIcon, levelIcon } from './breadcrumbs-hook';
import { Theme, Tooltip, createStyles, makeStyles } from '@material-ui/core';

export type ItemHierarchyContextType = { hierarchyPath: GridBreadcrumb[] };

const ItemHierarchyContext = createContext<ItemHierarchyContextType>({
  hierarchyPath: [],
});

export const ItemHierarchyContextProvider: React.FC<{
  value: ItemHierarchyContextType;
}> = ({ value, children }) => {
  const ctx = useMemo(() => value, [value]);
  return (
    <ItemHierarchyContext.Provider value={ctx}>
      {children}
    </ItemHierarchyContext.Provider>
  );
};

export const useItemHierarchyContext = () => useContext(ItemHierarchyContext);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    linkValue: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      marginRight: '8px',
    },
    tooltip: {
      fontSize: 14,
    },
  })
);

export const NavToParentField = () => {
  const { crumbs } = useEadTreeContext();
  const classes = useStyles();
  if (!crumbs || crumbs.length < 1) {
    return <></>;
  }
  const crumb = crumbs?.[crumbs.length - 2];
  const name = crumb?.label ?? '';
  const timeRange = crumb?.timeRange;
  const Icon = levelIcon[crumb?.level ?? 'fond'] ?? LevelDefaultIcon;

  return (
    <LinkFieldRouter
      label="Nadřazená úroveň"
      to={crumb?.to ?? '#'}
      value={
        <Tooltip
          title={
            <span className={classes.tooltip}>{crumb?.levelLabel ?? ''}</span>
          }
          placement="left-start"
          enterDelay={500}
          enterNextDelay={500}
        >
          <div className={classes.linkValue}>
            <Icon fontSize="small" className={classes.icon} />
            {`${name} ${timeRange ? timeRange : ''}`}
          </div>
        </Tooltip>
      }
      target="_self"
    />
  );
};
